import { httpRequest } from '@/request/utils/httprequest.js'
import baseUrl from '@/request/base.js'
import {baseconfig,rsaBasicModuleConfig} from '@/config.js'
import { rsa } from '@/tools/encrypt.js'
import { publicFun } from '@/tools/time.js'
import store from '@/store'
import qs from 'qs'
export const rewardFileModel = {

    // 奖扶对象列表 HYT
    async rewardrecordinfolist(page,pagesize,apply_class,policy_measure_id,key_words,account_nature,year,enjoy_census_region_level,enjoy_census_region_id,current_census_region_level,current_census_region_id,id_number) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + '~34CFD4d',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'rewardrecordinfolist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&pagesize=' + pagesize + '&key_words=' + key_words+ '&apply_class=' + apply_class+ '&policy_measure_id=' + policy_measure_id+ '&account_nature=' + account_nature+ '&year=' + year+ '&enjoy_census_region_level=' + enjoy_census_region_level+ '&enjoy_census_region_id=' + enjoy_census_region_id+ '&current_census_region_level=' + current_census_region_level+ '&current_census_region_id=' + current_census_region_id+ '&id_number=' + id_number  , 'get', null, null)
    },
 
    //申报审核-批量审核--CGX
    async applybatchaudit(apply_record_ids,user_ids,policy_measure_id,is_audit_pass,no_pass_reason,mark) {
        const adminToken = store.getters.adminID
        var paras = {
            policy_measure_id: policy_measure_id,
            user_ids: user_ids,
            apply_record_ids: apply_record_ids,
            is_audit_pass: is_audit_pass,
            no_pass_reason: no_pass_reason,
            mark:mark,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(apply_record_ids) + String(user_ids) + String(policy_measure_id)+ String(is_audit_pass) + 'sdajfkj',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applybatchaudit', 'post', qs.stringify(paras), null)
    },
}
export const logoutRewardFileModel = {

    // 退出奖扶对象列表 HYT
    async logoutrewardrecordinfolist(page,pagesize,policy_measure_id,key_words,account_nature,year,enjoy_census_region_level,enjoy_census_region_id,current_census_region_level,current_census_region_id,id_number) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + '~34CFD4d',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'logoutrewardrecordinfolist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&pagesize=' + pagesize + '&key_words=' + key_words+ '&policy_measure_id=' + policy_measure_id+ '&account_nature=' + account_nature+ '&year=' + year+ '&enjoy_census_region_level=' + enjoy_census_region_level+ '&enjoy_census_region_id=' + enjoy_census_region_id+ '&current_census_region_level=' + current_census_region_level+ '&current_census_region_id=' + current_census_region_id + '&id_number=' + id_number , 'get', null, null)
    },
   //奖扶对象退出/恢复 --HYT
   async recoverrewardrecordinfo(reward_record_id,is_person_logout,person_logout_reason_id,person_logout_reason_remark,census_emigration_place) {
    const adminToken = store.getters.adminID
    var paras = {
        reward_record_id: reward_record_id,
        is_person_logout: is_person_logout,
        person_logout_reason_id: person_logout_reason_id,
        person_logout_reason_remark: person_logout_reason_remark,
        census_emigration_place: census_emigration_place,
        timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
        _sign: rsa.signString(baseconfig.v + adminToken + String(reward_record_id)  + '~AS651324',rsaBasicModuleConfig.clientPrivateKey),
    }
    return await httpRequest(baseUrl.basic + 'recoverrewardrecordinfo', 'post', qs.stringify(paras), null)
},
}
// 迁出
export const moveoutrewardrecordinfolistModel = {

    // 列表 HYT
    // /moveoutrewardrecordinfolist
    async moveoutrewardrecordinfolist(page,pagesize,key_words,account_nature,enjoy_census_region_level,enjoy_census_region_id,id_number) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + '~34Casd4d',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'moveoutrewardrecordinfolist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&pagesize=' + pagesize + '&key_words=' + key_words+ '&account_nature=' + account_nature+ '&enjoy_census_region_level=' + enjoy_census_region_level+ '&enjoy_census_region_id=' + enjoy_census_region_id + '&id_number=' + id_number , 'get', null, null)
    },
   //  档案管理-迁出管理-迁出/区域调整--CGX
    // /censuschangesapply
    async censuschangesapply(reward_record_ids,policy_measure_ids,reward_user_ids,old_census_region_id,new_census_region_id,move_out_type) {
        const adminToken = store.getters.adminID
        var paras = {
            policy_measure_ids: policy_measure_ids,
            reward_user_ids: reward_user_ids,
            reward_record_ids: reward_record_ids,
            old_census_region_id: old_census_region_id,
            new_census_region_id: new_census_region_id,
            move_out_type:move_out_type,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            // +reward_record_ids+policy_measure_ids+reward_user_ids+old_census_region_id+new_census_region_id+move_out_type
            _sign: rsa.signString(baseconfig.v + adminToken + String(reward_record_ids) + String(policy_measure_ids) + String(reward_user_ids)+ String(old_census_region_id)+ String(new_census_region_id)+ String(move_out_type)  + 'dfsmk',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'censuschangesapply', 'post', qs.stringify(paras), null)
    },
}
// 迁入
export const moveinrewardrecordinfolistModel = {

    // 列表 HYT
    // /moveinrewardrecordinfolist
    async moveinrewardrecordinfolist(page,pagesize,key_words,year,audit_status,enjoy_census_region_level,enjoy_census_region_id,id_number) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + '~3sd45d4d',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'moveinrewardrecordinfolist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&pagesize=' + pagesize + '&year=' + year+ '&key_words=' + key_words+ '&audit_status=' + audit_status+ '&enjoy_census_region_level=' + enjoy_census_region_level+ '&enjoy_census_region_id=' + enjoy_census_region_id + '&id_number=' + id_number , 'get', null, null)
    },
   //  迁入受理审核--HYT
    // //censuschangesaudit
    async censuschangesaudit(census_changes_record_ids,audit_status,no_pass_reason_id,no_pass_reason) {
        const adminToken = store.getters.adminID
        var paras = {
            census_changes_record_ids: census_changes_record_ids,
            audit_status: audit_status,
            no_pass_reason_id: no_pass_reason_id,
            no_pass_reason: no_pass_reason,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            // census_changes_record_ids + audit_status + SADF11 
            _sign: rsa.signString(baseconfig.v + adminToken + String(census_changes_record_ids) + String(audit_status)  + 'SADF11',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'censuschangesaudit', 'post', qs.stringify(paras), null)
    },
}
// 普通用户
export const userlistModel = {

    // 列表 HYT
    ///userlist  普通用户列表--CGX
    async userlist(page,page_size,key_words,logout_status,auth_status,id_number) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + String(logout_status)+ String(auth_status)+'dfsnfdks',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words+ '&logout_status=' + logout_status+ '&auth_status=' + auth_status + '&id_number=' + id_number , 'get', null, null)
    },
    // /edituserlogout
    async edituserlogout(user_id,logout_reason_id) {
        const adminToken = store.getters.adminID
        var paras = {
            user_id: user_id,
            logout_reason_id: logout_reason_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(user_id)+ String(logout_reason_id )+'dnsjfks',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'edituserlogout', 'post', qs.stringify(paras), null)
    },
}



